import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import * as AWS from 'aws-sdk';
import { GetuserService } from './getuser.service';
declare var CryptoJS: any;
declare var Amplify: any;

@Injectable()
export class CognitoService {
  public cognitoIdentityServiceProvider: AWS.CognitoIdentityServiceProvider;
  clientId = '19k3f8uvhvm7lu7o4negrpdpnk';
  clientSecret = 'fo77mujj5lbpoqov8anp78hdgvhbfnpoggg5ri7hriar2au37ej';
  accessToken: string;
  currentUser: any;

  constructor( private _service: NotificationsService,
    private router: Router,
    private service: GetuserService
  ) {
    AWS.config.region = "us-east-2";
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: "us-east-2:3130093a-f27c-43e2-971b-139e0c92ef55",
    });
    this.cognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider();
  }

  private generateSecretHash(username: string): string {
    const message = CryptoJS.enc.Utf8.parse(username + this.clientId);
    const hash = CryptoJS.HmacSHA256(message, CryptoJS.enc.Utf8.parse(this.clientSecret));
    return CryptoJS.enc.Base64.stringify(hash);
  }

  confirmSignUp(username: string, confirmationCode: string): Promise<void> {
    const secretHash = this.generateSecretHash(username);
    const params = {
      ClientId: this.clientId,
      ConfirmationCode: confirmationCode,
      Username: username,
      SecretHash: secretHash,

    };
    return new Promise((resolve, reject) => {
      this.cognitoIdentityServiceProvider.confirmSignUp(params, (err, data) => {
        if (err) {
          this._service.error(err);
          reject(err);
        } else {
          this._service.success("User verified successfully.");
          resolve();
        }
      });
    });
  }

  signIn(username: string, password: string): Promise<void> {
    const secretHash = this.generateSecretHash(username);
    var params = {
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: this.clientId,
      AuthParameters: {
        USERNAME: username,
        PASSWORD: password,
        SECRET_HASH: secretHash
      }
    };
    return new Promise((resolve, reject) => {
      this.cognitoIdentityServiceProvider.initiateAuth(params, (err, data) => {
        if (err) {
          this._service.error(err);
          reject(err);
        } else {
          this._service.success('User login successfully.');
          localStorage.setItem("accessToken", data.AuthenticationResult.AccessToken);
          localStorage.setItem("idToken", data.AuthenticationResult.IdToken);
          resolve();
        }
      });
    });
  }

  signUp(model, cityName, stateName, countryName): Promise<void> {
    var is_buyer;
    var is_seller;
    const secretHash = this.generateSecretHash(model.email);

    is_buyer = model.is_buyer ? "1" : "0";
    is_seller = model.is_seller ? "1" : "0";
    const params = {
      ClientId: this.clientId,
      Password: model.password,
      Username: model.email,
      UserAttributes: [
        { Name: 'email', Value: model.email || '' },
        { Name: 'name', Value: model.first_name || '' },
        { Name: 'family_name', Value: model.first_name || '' },
        { Name: 'given_name', Value: model.first_name || '' },
        { Name: 'profile', Value: model.first_name || '' },
        { Name: 'custom:address', Value: model.address || '' },
        { Name: 'custom:city', Value: cityName || '' },
        { Name: 'custom:country', Value: countryName || '' },
        { Name: 'custom:device_tok', Value: '' },
        { Name: 'custom:device_typ', Value: '' },
        { Name: 'custom:email', Value: model.email || '' },
        { Name: 'custom:first_name', Value: model.first_name || '' },
        { Name: 'custom:image', Value: '' },
        { Name: 'custom:last_name', Value: model.last_name || '' },
        { Name: 'custom:state', Value: stateName || '' },
        { Name: 'custom:username', Value: model.username || '' },
        { Name: 'custom:zip_code', Value: model.zip_code || '' },
        { Name: 'custom:is_buyer_string', Value: is_buyer || '' },
        { Name: 'custom:is_seller_string', Value: is_seller || '' },
      ],
      SecretHash: secretHash,
    };
    return new Promise((resolve, reject) => {
      this.cognitoIdentityServiceProvider.signUp(params, (err, data) => {
        if (err) {
          this._service.error(err);
          reject(err);
        } else {
          this._service.success("Confirmation OTP send to your mail");
          resolve();
        }
      });
    });
  }

  forgotPassword(username: string): Promise<void> {
    const secretHash = this.generateSecretHash(username);
    var params = {
      ClientId: this.clientId,
      Username: username,
      SecretHash: secretHash
    };
    return new Promise((resolve, reject) => {
      this.cognitoIdentityServiceProvider.forgotPassword(params, (err, data) => {
        if (err) {
          if(err.code === "UserNotFoundException"){
            this._service.error("Please enter correct email this user doesn't exist.");
           }
           if(err.code === "CodeDeliveryFailureException"){
            this._service.error("Unable to send otp please try again later.");
           }
           if(err.code === "LimitExceededException"){
            this._service.error("Attempt limit exceeded, please try after some time.");
           }
           if(err.code === "InvalidParameterException"){
            this.service.username = username;
            this.service.isConfirmSignup = true;
            this.service.isForgetScreen = true;
           }
          
          reject(err);
        }
        else {
          this._service.success("Check you email id for account verification OTP.");
          resolve();
        }
      });
    });
  }

  confirmForgotPassword(username: string, confirmationCode: any, newPassword: string): Promise<void> {
    const secretHash = this.generateSecretHash(username);
    var params = {
      ClientId: this.clientId,
      ConfirmationCode: confirmationCode,
      Password: newPassword,
      Username: username,
      SecretHash: secretHash
    };
    let $this = this;
    return new Promise((resolve, reject) => {
      this.cognitoIdentityServiceProvider.confirmForgotPassword(params, (err, data) => {
        if (err) {
          this._service.error(err);
          reject(err);
        } else {         
          this._service.success("Password reset successfully.");
          resolve();
        }
      });
    });
  }

  changePassword(current_password: string, new_password: string, new_password_confirm: string): Promise<void> {

    if (new_password !== new_password_confirm) {
      alert("New password and confirm password do not match.");
      return;
    }
    this.accessToken = localStorage.getItem("accessToken");
    var params = {
      AccessToken: this.accessToken,
      PreviousPassword: current_password,
      ProposedPassword: new_password,
    };
    return new Promise((resolve, reject) => {
      this.cognitoIdentityServiceProvider.changePassword(params, (err, data) => {
        if (err) {
          reject(err);
        } else {
         
          alert("Password changed successfully.");
          resolve();
        }
      });
    });
  }

  resendOtp(username: string): Promise<void> {
    const secretHash = this.generateSecretHash(username);
    var params = {
      Username: username,
      ClientId: this.clientId,
      SecretHash: secretHash
    };
    return new Promise((resolve, reject) => {
      this.cognitoIdentityServiceProvider.resendConfirmationCode(params, (err, data) => {
        if (err) {
          this._service.error(err);
          reject(err);
        } else {
          this._service.success("OTP resend successfully");
          resolve();
        }
      });
    });
  }

  signOut(accessToken: string): Promise<void> {
    var params = {
      AccessToken: accessToken,
    };
    return new Promise((resolve, reject) => {
      this.cognitoIdentityServiceProvider.globalSignOut(params, (err, data) => {
        if (err) {
          reject(err);
        } else {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("idToken");
          resolve();
        }
      });
    });
  }


}





// WEBPACK FOOTER //
// ./src/app/_services/Cognito.service.ts